export const MAX_VOLUME = 100;
export const MIN_VOLUME = 0;
